import { OkResponseMessage } from "../types/backendDTOs";
import { IgPostDetailsDTO } from "../types/postDTOs";
import {
  API_URLS,
  UploadFile,
  appendFile,
  config,
  create,
  fetch,
  getApiClient,
} from "./client";

export const uploadPostCall = (images: UploadFile[], captions: string[]) => {
  const formData = new FormData();
  images.forEach((image) => appendFile(formData, "images", image));
  captions.forEach((caption) => formData.append("captions", caption));
  return getApiClient().post<IgPostDetailsDTO[]>(
    `${API_URLS().POSTS}/upload`,
    formData
  );
};

export const deletePostCall = (id: number) =>
  getApiClient().delete<OkResponseMessage>(`${API_URLS().POSTS}/${id}`);

export const likeOrUnlikePostCall = (id: number, action: string) =>
  create<OkResponseMessage>(
    `${API_URLS().POSTS}/${id}/like-unlike`,
    undefined,
    config({ action: action })
  );

export const fetchPostsByTypeCall = (
  type: string,
  page: number,
  count: number
) =>
  fetch<IgPostDetailsDTO[]>(
    API_URLS().POSTS,
    config({ type: type, page: page, count: count })
  );

export const fetchUserAllPostsCall = (
  id: string,
  page: number,
  count: number
) =>
  fetch<IgPostDetailsDTO[]>(
    `${API_URLS().POSTS}/user/${id}`,
    config({ page: page, count: count })
  );

export const fetchUserLikedPostsCall = (
  id: string,
  page: number,
  count: number
) =>
  fetch<IgPostDetailsDTO[]>(
    `${API_URLS().POSTS}/user/${id}/liked`,
    config({ page: page, count: count })
  );
